<template lang="pug">
  div(data-testid="card-tab-overall-tags")
    a.pull-right(v-if="editable" href="#" @click.prevent="modalSelTag.isOpen = true" data-testid="-link-edit") 編集
    h5 タグ

    selected-tag(v-if="value.length > 0" v-model="modalSelTag.selectedItems")
    span(v-else) {{app_lang.NO_SET}}

    portal(to="modal")
      //- タグ選択ダイアログ(初期設定タグをダイアログに読み込むため、名刺一覧情報読み込み完了まで存在させない)
      modal-sel-tag(v-model="modalSelTag", :useSubmit="true", @submit="submit")

      app-modal(v-model="modalError.isOpen" type="warning")
        template(slot="title") エラー
        h4 タグ情報の変更に失敗しました。
        p(v-if="modalError.message") {{modalError.message}}
        template(slot="footer", slot-scope="{close}")
          button.btn.btn-default(type="button" @click="close()") 閉じる
</template>

<script>
import AppModal from '@/components/templates/AppModal'
import SelectedTag from '@/components/molecules/SelectedTag'
import ModalSelTag from '@/components/organisms/ModalSelTag'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const PersonRepository = RepositoryFactory.get('person')

export default {
  name: 'CardTabOverallTags',
  components: { AppModal, SelectedTag, ModalSelTag },
  props: {
    /**
     * @param {String} value openflag
     */
    value: {
      type: Array,
      required: false,
      default () {
        return []
      }
    },
    editable: { type: Boolean, required: true },
    sidPerson: { type: [String, Number], required: false, default: '' }
  },
  data () {
    return {
      // タグ選択モーダル
      modalSelTag: {
        isOpen: false,
        selectedIds: [],
        selectedItems: [],
        mode: {
          isDispPv: null,
          canAddPv: null,
          isEdit: true
        }
      },
      modalError: {
        isOpen: false,
        message: ''
      }
    }
  },
  watch: {
    value (value) {
      this.modalSelTag.selectedItems = []
      this.modalSelTag.selectedIds = []
      this.setTagsData(value)
    }
  },
  created () {
    this.modalSelTag.mode.isDispPv = !this.isMgmt
    this.modalSelTag.mode.canAddPv = !this.isAgentPage

    this.setTagsData(this.value)
  },
  methods: {
    setTagsData (tags) {
      for (let tag of tags) {
        this.modalSelTag.selectedItems.push(tag)
        this.modalSelTag.selectedIds.push(tag.id)
      }
    },
    // 選択したタグに変更する
    submit (modalSelTag) {
      // 画面に表示しているタグを変更する
      const vm = this

      // API実行
      PersonRepository.putTags(this.sidPerson, modalSelTag.selectedIds, this.isMgmt)
        .then(function (response) {
          if (vm.isApiSuccess(response)) {
            vm.showToast('タグ情報を変更しました。', {type: 'success'})
            vm.modalSelTag.isOpen = false
            vm.modalSelTag.selectedItems = modalSelTag.selectedItems
            vm.modalSelTag.selectedIds = modalSelTag.selectedIds
            vm.$store.dispatch('reloadBcardList')
          }
        })
        .catch(function (error) {
          vm.modalError.message = error.message
          vm.modalError.isOpen = true
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/box/CardTabOverallTags.vue